Vendd.Scripts.load(function () {

    var $form = $('.loyalty-registration-container');

    if ($form.length < 1)
        return;

    var form = $form.get(0);

    form.InitLoyaltyRegistrationForm = function () {
        var form, formData, registrationFormPartial = "loyaltyRegistrationForm_A";
        var $areaWrapper, $postalCode, $region, $activitiesWrappers, $datepicker;

        form = $form.get(0);

        var $submitButton;

        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            }
        };

        form.initForm = function (model) {
            form.loading(true);

            if (model.ThirdPartyLoyaltyCode === 'qivos') model.ShowRegion = true;

            var html = Vendd.Handlebars.parse(registrationFormPartial, model);
            $form.html(html);
            form.bind();

            form.loading(false);
        };

        form.bind = function () {
            $formContainer = $('.x-loyalty-registration-form', $form);
            $postalCode = $('input[name="postalcode"]', $formContainer);
            $region = $('input[name="region"]', $formContainer);
            $areaWrapper = $('select[name="area"]', $formContainer);
            $activitiesWrappers = $('.form-row.activity', $formContainer);
            $datepicker = $('.datepicker', $formContainer);

            var loyaltyCode = $formContainer.data('code');

            $datepicker.datepicker({
                dateFormat: 'dd-mm-yy'
            });

            formData = {
                "firstName": $('input[name="firstName"]', $formContainer).val(),
                "lastName": $('input[name="lastName"]', $formContainer).val(),
                "mobilephone": $('input[name="mobilephone"]', $formContainer).val(),
                "birthdate": "",
                "postalcode": $postalCode.val(),
                "area": $('option', $areaWrapper).length > 0 ? $("option:selected", $areaWrapper).val() : "",
                "regionName": $('input[name="region"]', $formContainer).val(),
                "region": $('input[name="region"]', $formContainer).attr('data-regioncode'),
                "email": $('input[name="email"]', $formContainer).val(),
                "address": $('input[name="address"]', $formContainer).val(),
                "activities": [],
                "alreadyRegistered": $formContainer.hasClass('registered')
            };

            var valOpts = {
                firstName: {
                    required: 'firstname-required'
                },
                lastName: {
                    required: 'lastname-required'
                },
                email: {
                    required: 'email-required',
                    isEmail: 'email-invalid'
                },
                mobilephone: {
                    required: 'mobilephone-required'
                },
                address: {
                    required: 'address-required'
                },
                postalcode: {
                    required: 'postalcode-required'
                },
                area: {
                    required: 'area-required'
                }
            };

            if (loyaltyCode === 'qivos') {
                var extraValOpts = {
                    region: {
                        required: 'region-required'
                    }
                }
                $.extend(true, valOpts, extraValOpts);
            }

            $form.validationEngine(valOpts);

            var rf = $form.data('validationEngine');

            $submitButton = $('.js-submit-button', $form);

            $form.on('change', 'select[name]', function (e) {
                var $this = $(this);
                var fieldName = $this.attr('name');
                formData[fieldName] = $("option:selected", $this).text();
            });

            $form.on('keyup', 'input[name]', function (e) {

                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $submitButton.click();

                    return;
                };

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val();
                rf = $form.data('validationEngine');
                rf.validate(fieldName);
            });

            $form.on('change', 'input[name]', function () { //checkboxes
                var $this = $(this);

                if ($this.attr('type') !== 'checkbox') return;

                var fieldName = $this.attr('name');

                formData[fieldName] = this.checked;
            });

            $form.on('keyup', 'input[name="postalcode"]', $.debounce(500, function (e) {
                form.removeAreaOptions();

                var $this = $(this);
                var pCode = $this.val();
                var data = {};
                var modelData = {};

                $.extend(modelData, {
                    Country: "GR",
                    Area: ""
                });
                $.extend(data, {
                    model: modelData
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAreasForPostCode(data, pCode, false));
            }));

            $postalCode.keyup();

            $form.on('click', '.js-submit-button', function (e) {

                valOpts = $form.validationEngine();

                $form.validationEngine(valOpts);
                rf = $form.data('validationEngine');

                e.preventDefault();
                e.stopPropagation();

                if (rf.validate()) {
                    form.submit();
                }
            });

            $areaWrapper.change(function () {
                if (formData.area.length > 3) {
                    form.loading(true);
                    formData.area = $("option:selected", this).val();
                    if (loyaltyCode === 'qivos') {
                        form.loadRegion();
                    }
                }
            });
        };

        form.onSuccess = function (envelope) {
            form.loading(false);

            var response = envelope.message.data;

            if (response.StatusCode === 200) {
                form.removeIsRegistered();

                $('.js-error', $form).hide();
                $('.js-exists', $form).hide();
                $('.js-content', $form).hide();

                $('.js-success', $form).show();

            } else {
                if (response.StatusCode === 404) {
                    $('.js-error', $form).hide();

                } else {
                    $('.js-error', $form).show();
                };
            };

        };

        form.onFailure = function (envelope) {
            form.loading(false);
            $('.js-error', $form).show();
        };

        form.submit = function () {
            form.loading(true);

            form.getSelectedActivities();
            form.getBirthDate();

            $('input[name]:not([type="checkbox"]):not([type="radio"]), textarea[name]', $form).each(function () {
                formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
            });

            Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.SubmitForm(formData));
        };


        form.removeAreaOptions = function () {
            $areaWrapper.find('option').remove();
            $region.val('');
            $region.attr('data-regionCode', '');
        };

        form.bindAreaOptions = function (options) {
            if (options.length <= 0) return;

            form.loading(true);

            $areaWrapper.append($("<option disabled></option>").attr("value", "").text("Area"));

            if (options.length === 1) {
                $areaWrapper.append($("<option ></option>").attr("value", options[0].Name).text(options[0].Name).attr('selected', true));
                formData.area = options[0].Name;
                if (loyaltyCode === 'qivos') {
                    form.loadRegion();
                }
            } else if (options.length > 1) {
                $($areaWrapper.find('option')[0]).attr('selected', true);

                for (var i = 0; i < options.length; i++) {
                    $areaWrapper.append($("<option></option>").attr("value", options[i].Name).text(options[i].Name));
                }

                form.loading(false);
            }

        };

        form.loadRegion = function () {
            var area = formData.area;
            var postalCode = formData.postalcode;

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetPrefecture('GR', area, postalCode));
        };

        form.bindRegion = function (region) {
            $region.val(region.Name);
            $region.attr('data-regionCode', region.Code);

            formData.regionName = region.Name;
            formData.region = region.Code;

            form.loading(false);
        };

        form.getSelectedActivities = function () {
            formData.activities = [];

            $('input:checked', $activitiesWrappers).each(function (e) {
                var $this = $(this);
                formData.activities.push($this.attr('data-code'));
            });
        };

        form.getBirthDate = function () {
            formData.birthdate = $datepicker.datepicker().val();
        };

        form.isRegistered = function () {
            return sessionStorage.getItem('LoyaltyIsRegistered');
        };

        form.removeIsRegistered = function () {
            sessionStorage.removeItem('LoyaltyIsRegistered');
        };

        form.init = function () {
            var registered = form.isRegistered();
            Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetRegistrationForm(registered === "true"));
        };

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetRegistrationFormSuccess, form, function (envelope) {
            //change mobile in case vendd mobile is different from stored
            var storedMobile = sessionStorage.getItem('LoyaltyMobilePhone');
            if (storedMobile) {
                envelope.message.data.MobilePhone = envelope.message.data.MobilePhone !== storedMobile ?
                    storedMobile :
                    envelope.message.data.MobilePhone;
            }

            form.initForm(envelope.message.data);
        });
        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetRegistrationFormFailure, form, function (envelope) {
            form.loading(false);
            notyf.error('Something went wrong');
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCodeSuccess, form, function (envelope) {
            form.bindAreaOptions(envelope.message.data.model);
            //todo : validate area 
            form.loading(false);
        });
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCodeFailed, form, function () {
            //todo: handle error with a message
            form.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPrefectureSuccess, form, function (envelope) {
            //    form.bindRegion(envelope.message.data.model);
            //todo : validate region
            form.loading(false);
        });
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPrefectureFailed, form, function () {
            //todo: handle error with a message
            form.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitFormSuccess, form, form.onSuccess);
        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitFormFailure, form, form.onFailure);

        form.init();

    }
});